module.exports = __webpack_public_path__ + "static/media/ai-ad-massie.bfc91d82.mp4";